import { render, staticRenderFns } from "./BindUnitsView.vue?vue&type=template&id=8863229a"
import script from "./BindUnitsView.vue?vue&type=script&lang=js"
export * from "./BindUnitsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports